import React, {useState, useEffect, useRef, useMemo, forwardRef} from 'react'
import _ from 'lodash'
import classNames from 'classnames/bind'
import styles from './index.less'
import CopyIcon from "#components/CopyIcon";
import CopeWrapper from "#components/SForm/SFormElement/CopeWrapper";

const cx = classNames.bind(styles)

export type ElementWrapperProps = {
  changeInterceptor?: (value: any, oldValue: any) => Promise<any>, // 变更拦截器
  isCopyPlaceholder?: boolean, // 编辑模式，是否显示复制占位符
  value?: any,
  onChange?: (value: any) => void
  children?: React.ReactElement,

  view?: boolean, // 是否是查看模式
  placeholder?: string,
}

const SFormElementWrapper = forwardRef(function (props: ElementWrapperProps, parentRef) {
  const {value, onChange,children,
    isCopyPlaceholder,
    changeInterceptor,
    ...resProps} = props
  const [localValue, setLocalValue] = useState(value)
  const [childValue, setChildValue] = useState(value)


  // 对比子组件的值，本地值，和外部值，保持一致
  useEffect(() => {
    if (!changeInterceptor) return;
    if (!_.isEqual(value, localValue)) {
      setLocalValue(value)
      setChildValue(value)
    } else if (!_.isEqual(childValue, localValue)) {
      if (!changeInterceptor) {
        setLocalValue(childValue)
        onChange?.(childValue)
      } else {
        // 如果有拦截器，就先拦截，然后再设置值
        Promise.resolve(changeInterceptor(childValue, localValue)).then((newValue: any) => {
          setLocalValue(newValue)
          setChildValue(newValue)
          onChange?.(newValue)
        }).catch(() => {
          setChildValue(localValue)
        })
      }
    }
  }, [value, localValue, childValue])

  const result = useMemo(() => {
    if(changeInterceptor) {
      return {
        value: childValue,
        onChange: setChildValue
      }
    } else {
      return {
        value: value,
        onChange: onChange
      }
    }
  }, [changeInterceptor, childValue, value, onChange])

  return <>
    {React.cloneElement(children, {
      value: result.value,
      onChange: result.onChange,
      ref: parentRef,
      ...resProps
    })}
  </>


  return <CopeWrapper
      // isCopyPlaceholder={isCopyPlaceholder && !resProps.view}
      isCopyPlaceholder={false}
      placeholder={resProps.placeholder}
  >
    <>
      {React.cloneElement(children, {
        value: childValue,
        onChange: (value: any) => {
          setChildValue(value)
        },
        ref: parentRef,
        ...resProps
      })}
      {!!props.view && !!ableCopy && value && <CopyIcon text={value}  tipToolTitle={'复制'}/>}
    </>
  </CopeWrapper>
})


export default SFormElementWrapper